import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './details';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import OtherDetails from './otherDetails';
import Features from './feature';
import ImagesList from './images';
import EscrowAccount from './escrow';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const PropertyMasterView = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false]);
    const [loading, setloader] = useState(false)
    const [tableLoading, setTableLoading] = useState(false);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const location = useLocation();
    const leaseData = location.state;

    const [transectionData, setTransectionData] = useState({
        propertyNo: '',
        propertyName: '',
        plotNo: '',
        plotSize: '',
        remarks: '',
        propertyDescription: '',
        location: '',
        area: '',
        longitude: '',
        latitude: '',
        video: '',
        community: null,
        country: null,
        city: null,
        propertyType: null,
        ownerShip: null,
        projectStatus: null,
        category: null,
        propertyUse: null,
    });

    useEffect(() => {
        fetchDropdownData()
    }, []);
    const fetchDropdownData = async () => {
        try {
            if (leaseData) {
                const unitres = await apiService.getApiParamater('GET_PROPERTY_BY_ID', `/${leaseData?.property_No}`);
                let unitData = unitres?.data?.result?.property
                setTransectionData({
                    propertyNo: unitData?.property_No || '',
                    propertyName: unitData?.description || '',
                    plotNo: unitData?.plot_No || '',
                    plotSize: unitData?.plot_Size || '',
                    remarks: unitData?.remarks || '',
                    propertyDescription: unitData?.descriptionBI || '',
                    location: unitData?.location || '',
                    area: unitData?.gross_Area || '',
                    longitude: unitData?.longitude || '',
                    latitude: unitData?.latitude || '',
                    video: unitData?.exp7 || '',
                    community: unitData?.community_Name,
                    country: unitData?.country,
                    propertyType: unitData?.property_Type,
                    projectStatus: unitData?.project_Status,
                    ownerShip: unitData?.property_Class,
                    city: unitData?.city,
                    category: unitData?.property_Category,
                });
            }
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    return (
        <div className='p-3'>
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className=''><h6>Property Master</h6></div>
                <div className='d-flex gap-3'>
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)}>Images
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (<div className="cost-center-section my-3">
                <div className={`border-box2 p-3`}>
                    {tableLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                inset: 0,
                                background: 'rgba(255,255,255,0.6)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                            }}
                        >
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    )}
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Property No</label>
                            <input type="text" className="p-2 form-control w-75" disabled value={transectionData?.propertyNo} disabled name="propertyNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start"> Name *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.propertyName} disabled name="propertyName" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">Property Type *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.propertyType} disabled name="propertyType" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Plot No</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.plotNo} disabled name="plotNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">OwnerShip</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.ownerShip} disabled name="ownerShip" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Project Status</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.projectStatus} disabled name="projectStatus" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">Property Category *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.category} disabled name="category" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Plot Size </label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.plotSize} disabled name="plotSize" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.remarks} disabled name="remarks" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Property Description</label>
                            <textarea type="text" className="p-2 form-control w-75" value={transectionData?.propertyDescription} disabled name="propertyDescription" />
                        </div>
                    </div>
                </div>
                <div className={`border-box2 p-3`}>
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">Country *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.country} disabled name="country" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Location</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.location} disabled name="location" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">City *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.city} disabled name="city" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Area</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.area} disabled name="area" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom22" className="form-label">Community *</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.community} disabled name="community" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Longitude</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.longitude} disabled name="longitude" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Latitude</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.latitude} disabled name="latitude" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Video</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.video} disabled name="video" />
                        </div>
                    </div>
                </div>
            </div>)}
            {gridVisibility[3] && (<ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />)}
        </div>

    );
};
export default PropertyMasterView